// import moment from "moment"
// const newModel = () => {
//     return {
//         id: null,
//         username: null,
//         password: null,
//         repassword: null,
//         fullname: null,
//         email: null,
//         phoneNumber: null,
//         roleStr: null,
//         roles: [],
//         status: null,
//         createdAt: moment(Date.now()).format('YYYY-MM-DDTHH:mm:ss'),
//         createdBy: null,
//         updatedAt: moment(Date.now()).format('YYYY-MM-DDTHH:mm:ss'),
//         updatedBy: null
//     }
// }

// export const userModel = {
//     newModel
// }


import moment from "moment"
const newModel = () => {
    return {
        userId: null,
        userName: null,
        hoTen: null,
        gioiTinh: null,
        email: null,
        sdt: null,
        donViId: null,
        tenDonVi: null,
        chucDanhId: null,
        tenChucDanh: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        phuongXaId: null,
        tenPhuongXa: null,
        khomApId: null,
        tenKhomAp: null,
        toDanPhoId: null,
        tenToDanPho: null,
        duongPho: null,
        tenDuongPho: null,
        soNha: null,
        diaChi: null,
        lockoutEnabled: null,
        lockoutTime: null,
        dateCreated: null,
        appId: null,
        appName: null,

        username: null,
        password: null,
    }
}

export const userModel = {
    newModel
}
